import React, { useEffect, useMemo, useState } from "react";
import DropdownSelect from "../common/DropdownSelect";
import { Link, useNavigate } from "react-router-dom";
import Pagination from "../common/Pagination";
import Pagination2 from "../common/Pagination2";
import Slider from "rc-slider";
import { BaseURL, PageURLMaster } from "../../APIs/APIUrls";
import { featureOptions, properties2 } from "../../data/properties";
import {
  GetAllPropertyforWeb,
  GetAllPropertyTypesforWeb,
} from "../../APIs/APIHelperforWeb.js";
import { useSnackbar } from "notistack";
import { checkWhatsAppChatOptionById } from "../../APIs/VendorLoginAPI";
import { useLocation, useSearchParams } from "react-router-dom";
import LocationModal from "../modals/LocationSearch.js";
import KeywordSearch from "../modals/KeywordSearch.js";
import BlogDetails2 from "../blogs/BlogDetails2.jsx";
import Enquiry from "../modals/Enquiry.js";

export default function Properties4({
  setTitle,
  setDescription,
  setKeywords,
  setMetaImage,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const titleFromPath = (pathname || "").replace(/^\/+|\/+$/g, "");
  const titleUrl = searchParams.get("title") || titleFromPath;

  //pagination and search filter states
  const [page, setPage] = useState(1);
  const [ItemsPerPage, setItemsPerPage] = useState(5);
  const [SearchTerm, setSearchTerm] = useState("");
  const [PropertyStatus, setPropertyStatus] = React.useState("");

  const [price, setPrice] = useState([1800, 5500]);
  const [size, setSize] = useState([800, 2200]);
  const [rooms, setRooms] = useState("All");
  const [bedrooms, setBedrooms] = useState("All");
  const [bathrooms, setBathrooms] = useState("All");
  const [type, setType] = useState("All");
  const [features, setFeatures] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [sortingOption, setSortingOption] = useState("Sort by (Default)");
  const [sorted, setSorted] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setitemPerPage] = useState(8);

  const [filteredProperties, setFilteredProperties] = useState([]);
  const [allProperties, setAllProperties] = useState([]);
  const [top8Properties, setTop8Properties] = useState([]);
  const [PropertyTypes, setPropertyTypes] = useState([]);
  const [selectedAreaFilter, setSelectedAreaFilter] = useState("");

  const [pageUrlMasterData, setPageUrlMasterData] = useState([]);
  const [filteredpageUrlMasterData, setFilteredPageUrlMasterData] = useState(
    [],
  );

  const [Value, setValue] = useState("");
  const [findScreenWidth, setFindScreenWidth] = useState(0);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState("");

  const [modalOpenKeyword, setModalOpenKeyword] = useState(false);
  const [selectedLocationKeyword, setSelectedLocationKeyword] = useState("");
  const [PropertyId, setPropertyId] = useState(null);
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);
  const [FlagType, setFlagType] = useState("");

  const handleOpenEnquiry = (flagType, PropertyId) => {
    setFlagType(flagType);
    setIsEnquiryOpen(true);
    setPropertyId(PropertyId);
  };

  const handleCloseEnquiry = () => setIsEnquiryOpen(false);

  const handleEnquirySubmit = () => {
    setIsEnquiryOpen(false);
  };

  const handleWhatsAppClick = async (property) => {
    try {
      const vendorId =
        property?.VendorId ||
        property?.vendorid ||
        property?.vendorId ||
        property?.Vendor ||
        0;
      const res = await checkWhatsAppChatOptionById(vendorId);
      if (!res || !res.success) {
        handleOpenEnquiry("whatsapp", property.PropertyId);
        return;
      }
      const info = res.data || {};
      const isOn = info.IsWhatsAppChat === true;
      const mobile = (info.Mobile || "").toString().trim();
      if (isOn) {
        if (mobile) {
          const cleaned = mobile.replace(/[^0-9+]/g, "");
          const text = encodeURIComponent(
            "Hi, I am interested in your property\n " +
              property.PropertyGeneratedId +
              " | " +
              property.PropertyTitle +
              "\n Property Link: " +
              window.location.href +
              `property-details/${property.AutoGeneratedURL}`,
          );
          const url = `https://api.whatsapp.com/send?phone=${cleaned}&text=${text}`;
          window.open(url, "_blank");
        } else {
          handleOpenEnquiry("whatsapp", property.PropertyId);
        }
      } else {
        handleOpenEnquiry("whatsapp", property.PropertyId);
      }
    } catch (error) {
      enqueueSnackbar &&
        enqueueSnackbar("Unable to start WhatsApp chat", { variant: "error" });
      handleOpenEnquiry("whatsapp", property.PropertyId);
    }
  };

  const normalizeToken = (value) =>
    (value || "")
      .toString()
      .toLowerCase()
      .trim()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");

  const normalizeText = (value) =>
    (value || "")
      .toString()
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9\s]/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  const getSlugFilters = (slugValue) => {
    const slug = normalizeToken(decodeURIComponent(slugValue || ""));
    if (!slug) {
      return { propertyTypeToken: "", statusToken: "", locationToken: "" };
    }

    const [left, locationTokenRaw] = slug.split("-in-");
    const locationToken = locationTokenRaw || "";
    const leftPart = left || slug;

    let propertyTypeToken = "";
    let statusToken = "";

    if (leftPart.includes("-for-sale")) {
      propertyTypeToken = leftPart.replace("-for-sale", "");
      statusToken = "sale";
    } else if (leftPart.includes("-for-rent")) {
      propertyTypeToken = leftPart.replace("-for-rent", "");
      statusToken = "rent";
    } else {
      propertyTypeToken = leftPart;
    }

    return { propertyTypeToken, statusToken, locationToken };
  };

  const filterPropertiesByTitle = (properties, slugValue) => {
    if (!slugValue) {
      return properties;
    }

    const normalizedSlug = normalizeToken(decodeURIComponent(slugValue));
    const { propertyTypeToken, statusToken, locationToken } =
      getSlugFilters(slugValue);

    const filtered = (properties || []).filter((property) => {
      const directSlugFields = [
        property?.Slug,
        property?.UrlSlug,
        property?.URLSlug,
        property?.SeoUrl,
        property?.Permalink,
      ]
        .map(normalizeToken)
        .filter(Boolean);

      if (directSlugFields.includes(normalizedSlug)) {
        return true;
      }

      const propertyTypeName = normalizeToken(property?.PropertyTypeName);
      const projectTypeName = normalizeToken(property?.ProjectTypeName);
      const statusName = normalizeText(property?.StatusName);
      const city = normalizeToken(property?.City);
      const state = normalizeToken(property?.State);
      const area = normalizeToken(property?.Area);
      const address = normalizeToken(property?.Address);

      const propertyTypeMatch =
        !propertyTypeToken ||
        propertyTypeName.includes(propertyTypeToken) ||
        projectTypeName.includes(propertyTypeToken) ||
        propertyTypeToken.includes(propertyTypeName) ||
        propertyTypeToken.includes(projectTypeName);

      const statusMatch = !statusToken || statusName.includes(statusToken);

      const locationMatch =
        !locationToken ||
        city.includes(locationToken) ||
        state.includes(locationToken) ||
        area.includes(locationToken) ||
        address.includes(locationToken);

      return propertyTypeMatch && statusMatch && locationMatch;
    });

    return filtered;
  };

  const clearFilter = () => {
    setPrice([1800, 5500]);
    setSize([800, 2200]);
    setRooms("All");
    setBedrooms("All");
    setBathrooms("All");
    setType("All");
    setFeatures([]);
  };

  const fetchProperties = async () => {
    try {
      const allProperties =
        JSON.parse(localStorage.getItem("AllPropertiesforWeb")) || [];
      const featuredProperties =
        JSON.parse(localStorage.getItem("AllFeaturedPropertiesforWeb")) || [];
      const allPropertyTypes =
        JSON.parse(localStorage.getItem("AllPropertyTypesforWeb")) || [];
      const timeStamp =
        JSON.parse(localStorage.getItem("TimeStampforData")) || 0;

      if (
        allProperties.length === 0 ||
        featuredProperties.length === 0 ||
        allPropertyTypes.length === 0 ||
        new Date().getTime() > timeStamp
      ) {
        await GetAllPropertyforWeb(enqueueSnackbar);
      }
    } catch (error) {
      console.error("Error fetching properties:", error);
      enqueueSnackbar("Failed to fetch properties. Please try again later.", {
        variant: "error",
      });
    }
  };

  useEffect(() => {
    fetchProperties();
  }, []);

  useEffect(() => {
    const fetchAllPageUrlMasterForWeb = async () => {
      try {
        const response = await fetch(
          `${PageURLMaster}GetAllPageURLMasterforWeb`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({}),
          },
        );

        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        const result = await response.json();
        const rows = result?.data || result?.Data || [];

        setPageUrlMasterData(rows);

        var matchedUrl = rows.find(
          (item) => normalizeToken(item?.PageURL) === normalizeToken(titleUrl),
        );
        if (matchedUrl) {
          setFilteredPageUrlMasterData(matchedUrl);
          setMetaImage(BaseURL + matchedUrl?._objDetailPage?.ImagePath);

          setTitle?.(matchedUrl?._objMeta?.Title);
          setDescription?.(matchedUrl?._objMeta?.Description);
          setKeywords?.(matchedUrl?._objMeta?.Keyword);

          const city = normalizeText(matchedUrl?.City);
          const state = normalizeText(matchedUrl?.State);
          const propertyTypeValue = normalizeText(matchedUrl?.PropertyTypeName);

          const allProperties =
            JSON.parse(localStorage.getItem("AllPropertiesforWeb")) || [];
          const filterbyurlproperties = allProperties.filter((property) => {
            const Area = normalizeText(property?.Area);
            const City = normalizeText(property?.CityName);
            const State = normalizeText(property?.StateName);
            const PropertyTypeName = normalizeText(property?.PropertyTypeName);

            return (
              City.includes(city) &&
              State.includes(state) &&
              PropertyTypeName.includes(propertyTypeValue)
            );
          });

          setFilteredProperties(filterbyurlproperties);

          const top8properties =
            JSON.parse(
              localStorage.getItem("TopandLatest_8_PropertiesforWeb"),
            ) || [];
          const filterbyurlpropertieslocation = top8properties.filter(
            (item) => {
              const City = normalizeText(item?.CityName);
              return City.includes(city);
            },
          );

          setTop8Properties(filterbyurlpropertieslocation);
        } else {
          enqueueSnackbar("no page found", { variant: "warning" });
          navigate("/404", { replace: true });
        }
      } catch (error) {
        console.error("GetAllPageURLMasterforWeb error:", error);
      }
    };

    fetchAllPageUrlMasterForWeb();
  }, [titleUrl, setTitle, setDescription]);

  useEffect(() => {
    if (sortingOption === "Price Ascending") {
      setSorted([...filtered].sort((a, b) => a.price - b.price));
    } else if (sortingOption === "Price Descending") {
      setSorted([...filtered].sort((a, b) => b.price - a.price));
    } else {
      setSorted(filtered); // Return items in their original order
    }

    setCurrentPage(1);
  }, [filtered, sortingOption]);

  useEffect(() => {
    const updateScreenWidth = () => {
      setFindScreenWidth(window.innerWidth);
    };

    updateScreenWidth();
    window.addEventListener("resize", updateScreenWidth);

    return () => {
      window.removeEventListener("resize", updateScreenWidth);
    };
  }, []);

  const allProps = {
    price,
    setPrice,
    size,
    setSize,
    setRooms,
    setBedrooms,
    setBathrooms,
    type,
    setType,
    features,
    setFeatures,
  };

  const returnCardImage = (propertyid, PropertyImages) => {
    if (!PropertyImages || !PropertyImages.length) {
      return "https://via.placeholder.com/615x405?text=No+Image";
    }
    const cardImage = PropertyImages.filter(
      (x) => x.IsCard === true && x.PropertyId == propertyid,
    )?.[0]?.ImageURL;
    return cardImage
      ? BaseURL + cardImage
      : "https://via.placeholder.com/615x405?text=No+Image";
  };

  const getFinalFilteredData = async () => {
    let finalData = [];

    const locationValue = normalizeForCompare(selectedLocation);
    const propertyTypeValue = normalizeForCompare(selectedLocationKeyword);
    const statusValue = normalizeText(PropertyStatus);

    let rows = pageUrlMasterData;

    // Fallback: fetch again at click time if not loaded yet
    if (!Array.isArray(rows) || rows.length === 0) {
      try {
        const response = await fetch(
          `${PageURLMaster}GetAllPageURLMasterforWeb`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({}),
          },
        );

        if (response.ok) {
          const result = await response.json();
          rows = result?.data || result?.Data || [];
          rows = Array.isArray(rows) ? rows : [];
          setPageUrlMasterData(rows);
        }
      } catch (error) {
        console.error("GetAllPageURLMasterforWeb click-fetch error:", error);
      }
    }

    if (rows.length > 0 && locationValue && propertyTypeValue) {
      const activeRows = rows.filter((item) => item?.IsActive === true);
      debugger;
      const cityAndTypeRows = activeRows.filter(
        (item) =>
          locationValue === normalizeForCompare(item?.City) &&
          propertyTypeValue === normalizeForCompare(item?.PropertyTypeName),
      );

      const statusMatchedRows = cityAndTypeRows.filter((item) => {
        if (!statusValue) return true;

        const pageUrl = normalizeText(
          item?.PageURL || item?.PageUrl || item?.pageURL,
        );
        const pageTitle = normalizeText(item?.PageTitle);
        const haystack = `${pageUrl} ${pageTitle}`;

        if (statusValue === "sale") {
          return haystack.includes("for-sale") || haystack.includes("sale");
        }

        if (statusValue === "rent") {
          return haystack.includes("for-rent") || haystack.includes("rent");
        }

        return true;
      });

      const matchedRow = statusMatchedRows[0] || cityAndTypeRows[0];

      const pageUrl = resolvePageUrlPath(
        matchedRow?.PageURL || matchedRow?.PageUrl || matchedRow?.pageURL,
      );

      if (pageUrl) {
        if (/^https?:\/\//i.test(pageUrl)) {
          window.location.href = pageUrl;
        } else {
          navigate(pageUrl);
        }
        return;
      }
    }
  };

  const normalizeForCompare = (value) =>
    normalizeText(value)
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  const resolvePageUrlPath = (rawUrl) => {
    const url = (rawUrl || "").toString().trim();
    if (!url) return "";

    // Absolute URL from API
    if (/^https?:\/\//i.test(url)) {
      return url;
    }

    // Relative/slug URL from API
    return url.startsWith("/") ? url : `/${url}`;
  };

  const areaFilters = useMemo(() => {
    const areaMap = new Map();
    filteredProperties.forEach((property) => {
      const areaValue = (property?.AreaName || "").toString().trim();
      const key = normalizeText(areaValue);
      if (key && !areaMap.has(key)) {
        areaMap.set(key, areaValue);
      }
    });
    return Array.from(areaMap.values()).sort((a, b) =>
      normalizeText(a).localeCompare(normalizeText(b)),
    );
  }, [filteredProperties]);

  const visibleProperties = useMemo(() => {
    if (!selectedAreaFilter) return filteredProperties;
    return filteredProperties.filter(
      (property) =>
        normalizeText(property?.AreaName) === normalizeText(selectedAreaFilter),
    );
  }, [filteredProperties, selectedAreaFilter]);

  useEffect(() => {
    setPage(1);
  }, [selectedAreaFilter]);

  useEffect(() => {
    if (
      selectedAreaFilter &&
      !areaFilters.some(
        (area) => normalizeText(area) === normalizeText(selectedAreaFilter),
      )
    ) {
      setSelectedAreaFilter("");
    }
  }, [areaFilters, selectedAreaFilter]);

  return (
    <>
      <section className="flat-section flat-recommended flat-sidebar">
        <div className="container">
          <div className="box-title-listing">
            <div
              className="box-left"
              style={{
                flexDirection: "column",
                gap: "5px",
                alignItems: "flex-start",
              }}
            >
              <h1 className="fw-8" style={{ fontSize: "1.8rem", margin: 0 }}>
                {filteredpageUrlMasterData?._objDetailPage?.Title}
              </h1>
              <p className="text">
                There are currently {visibleProperties.length} properties.
              </p>
            </div>
            <div className="box-filter-tab">
              <ul className="nav-tab-filter" role="tablist">
                <li className="nav-tab-item" role="presentation">
                  <a
                    href="#gridLayout"
                    className="nav-link-item active"
                    data-bs-toggle="tab"
                  >
                    <svg
                      className="icon"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.54883 5.90508C4.54883 5.1222 5.17272 4.5 5.91981 4.5C6.66686 4.5 7.2908 5.12221 7.2908 5.90508C7.2908 6.68801 6.66722 7.3101 5.91981 7.3101C5.17241 7.3101 4.54883 6.68801 4.54883 5.90508Z"
                        stroke="#A3ABB0"
                      />
                      <path
                        d="M10.6045 5.90508C10.6045 5.12221 11.2284 4.5 11.9755 4.5C12.7229 4.5 13.3466 5.1222 13.3466 5.90508C13.3466 6.68789 12.7227 7.3101 11.9755 7.3101C11.2284 7.3101 10.6045 6.68794 10.6045 5.90508Z"
                        stroke="#A3ABB0"
                      />
                      <path
                        d="M19.4998 5.90514C19.4998 6.68797 18.8757 7.31016 18.1288 7.31016C17.3818 7.31016 16.7578 6.68794 16.7578 5.90508C16.7578 5.12211 17.3813 4.5 18.1288 4.5C18.8763 4.5 19.4998 5.12215 19.4998 5.90514Z"
                        stroke="#A3ABB0"
                      />
                      <path
                        d="M7.24249 12.0098C7.24249 12.7927 6.61849 13.4148 5.87133 13.4148C5.12411 13.4148 4.5 12.7926 4.5 12.0098C4.5 11.2268 5.12419 10.6045 5.87133 10.6045C6.61842 10.6045 7.24249 11.2267 7.24249 12.0098Z"
                        stroke="#A3ABB0"
                      />
                      <path
                        d="M13.2976 12.0098C13.2976 12.7927 12.6736 13.4148 11.9266 13.4148C11.1795 13.4148 10.5557 12.7928 10.5557 12.0098C10.5557 11.2266 11.1793 10.6045 11.9266 10.6045C12.6741 10.6045 13.2976 11.2265 13.2976 12.0098Z"
                        stroke="#A3ABB0"
                      />
                      <path
                        d="M19.4516 12.0098C19.4516 12.7928 18.828 13.4148 18.0807 13.4148C17.3329 13.4148 16.709 12.7926 16.709 12.0098C16.709 11.2268 17.3332 10.6045 18.0807 10.6045C18.8279 10.6045 19.4516 11.2266 19.4516 12.0098Z"
                        stroke="#A3ABB0"
                      />
                      <path
                        d="M4.54297 18.0945C4.54297 17.3116 5.16709 16.6895 5.9143 16.6895C6.66137 16.6895 7.28523 17.3114 7.28523 18.0945C7.28523 18.8776 6.66139 19.4996 5.9143 19.4996C5.16714 19.4996 4.54297 18.8771 4.54297 18.0945Z"
                        stroke="#A3ABB0"
                      />
                      <path
                        d="M10.5986 18.0945C10.5986 17.3116 11.2227 16.6895 11.97 16.6895C12.7169 16.6895 13.3409 17.3115 13.3409 18.0945C13.3409 18.8776 12.7169 19.4996 11.97 19.4996C11.2225 19.4996 10.5986 18.8772 10.5986 18.0945Z"
                        stroke="#A3ABB0"
                      />
                      <path
                        d="M16.752 18.0945C16.752 17.3115 17.376 16.6895 18.1229 16.6895C18.8699 16.6895 19.4939 17.3115 19.4939 18.0945C19.4939 18.8776 18.8702 19.4996 18.1229 19.4996C17.376 19.4996 16.752 18.8772 16.752 18.0945Z"
                        stroke="#A3ABB0"
                      />
                    </svg>
                  </a>
                </li>
                <li className="nav-tab-item" role="presentation">
                  <a
                    href="#listLayout"
                    className="nav-link-item"
                    data-bs-toggle="tab"
                  >
                    <svg
                      className="icon"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.2016 17.8316H8.50246C8.0615 17.8316 7.7041 17.4742 7.7041 17.0332C7.7041 16.5923 8.0615 16.2349 8.50246 16.2349H19.2013C19.6423 16.2349 19.9997 16.5923 19.9997 17.0332C19.9997 17.4742 19.6426 17.8316 19.2016 17.8316Z"
                        fill="#A3ABB0"
                      />
                      <path
                        d="M19.2016 12.8199H8.50246C8.0615 12.8199 7.7041 12.4625 7.7041 12.0215C7.7041 11.5805 8.0615 11.2231 8.50246 11.2231H19.2013C19.6423 11.2231 19.9997 11.5805 19.9997 12.0215C20 12.4625 19.6426 12.8199 19.2016 12.8199Z"
                        fill="#A3ABB0"
                      />
                      <path
                        d="M19.2016 7.80913H8.50246C8.0615 7.80913 7.7041 7.45173 7.7041 7.01077C7.7041 6.5698 8.0615 6.2124 8.50246 6.2124H19.2013C19.6423 6.2124 19.9997 6.5698 19.9997 7.01077C19.9997 7.45173 19.6426 7.80913 19.2016 7.80913Z"
                        fill="#A3ABB0"
                      />
                      <path
                        d="M5.0722 8.1444C5.66436 8.1444 6.1444 7.66436 6.1444 7.0722C6.1444 6.48004 5.66436 6 5.0722 6C4.48004 6 4 6.48004 4 7.0722C4 7.66436 4.48004 8.1444 5.0722 8.1444Z"
                        fill="#A3ABB0"
                      />
                      <path
                        d="M5.0722 13.0941C5.66436 13.0941 6.1444 12.6141 6.1444 12.0219C6.1444 11.4297 5.66436 10.9497 5.0722 10.9497C4.48004 10.9497 4 11.4297 4 12.0219C4 12.6141 4.48004 13.0941 5.0722 13.0941Z"
                        fill="#A3ABB0"
                      />
                      <path
                        d="M5.0722 18.0433C5.66436 18.0433 6.1444 17.5633 6.1444 16.9711C6.1444 16.379 5.66436 15.8989 5.0722 15.8989C4.48004 15.8989 4 16.379 4 16.9711C4 17.5633 4.48004 18.0433 5.0722 18.0433Z"
                        fill="#A3ABB0"
                      />
                    </svg>
                  </a>
                </li>
              </ul>

              <DropdownSelect
                onChange={(value) => {
                  const match = value.match(/\d+/); // Match the digits in the value
                  if (match) {
                    setItemsPerPage(parseInt(match[0], 10)); // Parse the first matched number

                    // setCurrentPage(1);
                  }
                }}
                addtionalParentClass="list-page"
                options={[
                  "Show: 5",
                  "Show: 10",
                  "Show: 15",
                  "Show: 20",
                  "Show: 25",
                  "Show: 30",
                  "Show: 50",
                  "Show: 100",
                ]}
                setValue={setValue}
              />

              <DropdownSelect
                onChange={setSortingOption}
                addtionalParentClass="list-sort"
                options={[
                  "Sort by (Default)",

                  "Price Ascending",
                  "Price Descending",
                ]}
                setValue={setValue}
              />
            </div>
          </div>
          <div className="row">
            {findScreenWidth > 991 ? (
              <>
                <div className="col-xl-4 col-lg-5">
                  <div className="widget-sidebar fixed-sidebar">
                    <div className="flat-tab flat-tab-form widget-filter-search widget-box">
                      <ul className="nav-tab-form" role="tablist">
                        <li className="nav-tab-item" role="presentation">
                          <a
                            className="nav-link-item active"
                            data-bs-toggle="tab"
                            onClick={() => setPropertyStatus("Rent")}
                          >
                            Rent
                          </a>
                        </li>
                        <li className="nav-tab-item" role="presentation">
                          <a
                            className="nav-link-item"
                            data-bs-toggle="tab"
                            onClick={() => setPropertyStatus("Sell")}
                          >
                            Sale
                          </a>
                        </li>
                        <li className="nav-tab-item" role="presentation">
                          <a
                            className="nav-link-item"
                            data-bs-toggle="tab"
                            onClick={() => setPropertyStatus("PG")}
                          >
                            PG
                          </a>
                        </li>
                      </ul>
                      <div className="tab-content">
                        <div
                          className="tab-pane fade active show"
                          role="tabpanel"
                        >
                          <div className="form-sl">
                            <form onSubmit={(e) => e.preventDefault()}>
                              <div className="wd-filter-select">
                                <div className="inner-group">
                                  <div className="box">
                                    <div className="form-style">
                                      <div className="group-ip ip-icon">
                                        <input
                                          type="text"
                                          className="form-control"
                                          defaultValue=""
                                          name="s"
                                          title="Search for"
                                          required
                                          value={selectedLocation}
                                          onClick={() => setModalOpen(true)}
                                          readOnly
                                          placeholder="Search by location"
                                        />
                                        <a
                                          className="icon-right icon-location"
                                          onClick={() => {
                                            setModalOpen(true);
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <LocationModal
                                      isOpen={modalOpen}
                                      onClose={() => setModalOpen(false)}
                                      onSelect={setSelectedLocation}
                                    />
                                    <div className="form-style">
                                      <input
                                        type="text"
                                        className="form-control"
                                        defaultValue=""
                                        title="Search for"
                                        required
                                        placeholder="Search Keyword"
                                        name="s"
                                        value={selectedLocationKeyword}
                                        onClick={() =>
                                          setModalOpenKeyword(true)
                                        }
                                      />
                                    </div>
                                    <KeywordSearch
                                      isOpen={modalOpenKeyword}
                                      onClose={() => setModalOpenKeyword(false)}
                                      onSelect={setSelectedLocationKeyword}
                                      LocationName={selectedLocation}
                                    />

                                    {/* <div className="form-style">
                                    <div className="group-select">
                                      <DropdownSelect
                                        defaultOption="Property type"
                                        onChange={setType}
                                        options={[
                                          "All",
                                          "Villa",
                                          "Studio",
                                          "Office",
                                          "House",
                                        ]}
                                      />
                                    </div>
                                  </div>
                                  <div className="form-style box-select">
                                    <DropdownSelect
                                      defaultOption="Room"
                                      onChange={setRooms}
                                      options={["All", 1, 2, 3, 4, 5]}
                                    />
                                  </div>
                                  <div className="form-style box-select">
                                    <DropdownSelect
                                      defaultOption="Bathrooms"
                                      onChange={setBathrooms}
                                      options={["All", 1, 2, 3, 4, 5]}
                                    />
                                  </div>
                                  <div className="form-style box-select">
                                    <DropdownSelect
                                      defaultOption="Bedrooms"
                                      onChange={setBedrooms}
                                      options={["All", 1, 2, 3, 4, 5]}
                                    />
                                  </div> */}
                                  </div>
                                  {/* <div className="box">
                                  <div className="form-style widget-price">
                                    <div className="box-title-price">
                                      <span className="title-price fw-6">
                                        Price:
                                      </span>
                                      <div className="caption-price">
                                        <span
                                          id="slider-range-value1"
                                          className="fw-6"
                                        >
                                          {" "}
                                          ${price[0]}{" "}
                                        </span>
                                        <span>-</span>
                                        <span
                                          id="slider-range-value2"
                                          className="fw-6"
                                        >
                                          ${price[1]}
                                        </span>
                                      </div>
                                    </div>
                                    <Slider
                                      range
                                      // formatLabel={() => ``}
                                      max={6000}
                                      min={1500}
                                      value={price}
                                      onChange={setPrice}
                                    />
                                  </div>
                                  <div className="form-style widget-price wd-price-2">
                                    <div className="box-title-price">
                                      <span className="title-price fw-6">
                                        Size:
                                      </span>
                                      <div className="caption-price">
                                        <span
                                          id="slider-range-value1"
                                          className="fw-6"
                                        >
                                          {" "}
                                          ${size[0]}{" "}
                                        </span>
                                        <span>-</span>
                                        <span
                                          id="slider-range-value2"
                                          className="fw-6"
                                        >
                                          ${size[1]}
                                        </span>
                                      </div>
                                    </div>
                                    <Slider
                                      range
                                      // formatLabel={() => ``}
                                      max={2500}
                                      min={500}
                                      value={size}
                                      onChange={setSize}
                                    />
                                  </div>
                                </div>
                                <div className="box">
                                  <div className="form-style wd-amenities">
                                    <div className="group-checkbox">
                                      <h6 className="title text-black-2">
                                        Amenities:
                                      </h6>
                                      <div className="group-amenities">
                                        {featureOptions.map((feature, index) => (
                                          <fieldset
                                            key={`cb${index + 1}`}
                                            className={`amenities-item `}
                                            onClick={() =>
                                              setFeatures((pre) =>
                                                pre.includes(feature)
                                                  ? [
                                                    ...pre.filter(
                                                      (elm) => elm != feature
                                                    ),
                                                  ]
                                                  : [...pre, feature]
                                              )
                                            }
                                          >
                                            <input
                                              readOnly
                                              checked={features.includes(feature)}
                                              type="checkbox"
                                              className="tf-checkbox style-1"
                                            />
                                            <label className="text-cb-amenities">
                                              {feature}
                                            </label>
                                          </fieldset>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                </div> */}
                                  {/* <a
                                  className="tf-btn btn-linemt-5 clear-filter"
                                  onClick={clearFilter}
                                >
                                  Clear Filter
                                </a> */}
                                  <div className="form-style">
                                    <button
                                      type="submit"
                                      className="tf-btn btn-view primary hover-btn-view"
                                      onClick={() => getFinalFilteredData()}
                                    >
                                      Find Properties
                                      <span className="icon icon-arrow-right2" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="widget-box box-latest-property">
                      <h5 className="fw-6 title">Latest Propeties</h5>
                      <ul>
                        {top8Properties.map((property, index) => (
                          <li key={index} className="latest-property-item">
                            <Link
                              to={`/property-details/${property.AutoGeneratedURL}`}
                              className="images-style"
                            >
                              <img
                                data-src={returnCardImage(
                                  property.PropertyId,
                                  property._lstPropertyImages,
                                )}
                                alt={property?.PropertyTitle}
                                src={returnCardImage(
                                  property.PropertyId,
                                  property._lstPropertyImages,
                                )}
                                width={615}
                                height={405}
                                loading="lazy"
                              />
                            </Link>
                            <div className="content">
                              <div className="text-capitalize text-btn">
                                <Link
                                  to={`/property-details/${property.AutoGeneratedURL}`}
                                  className="link"
                                >
                                  {property.PropertyGeneratedId}{" "}
                                  &nbsp;&nbsp;|&nbsp;&nbsp;
                                  {property.PropertyFor}{" "}
                                  &nbsp;&nbsp;|&nbsp;&nbsp;{" "}
                                  {property.PropertyTitle}
                                </Link>
                              </div>
                              <ul className="meta-list mt-6">
                                {property.NoofRoom && (
                                  <>
                                    <li className="item">
                                      <i className="icon icon-bed" />
                                      <span className="text-variant-1">
                                        Beds:
                                      </span>
                                      <span className="fw-6">
                                        {property.NoofRoom}
                                      </span>
                                    </li>
                                  </>
                                )}
                                {property.NoofWashroom && (
                                  <li className="item">
                                    <i className="icon icon-bath" />
                                    <span className="text-variant-1">
                                      Baths:
                                    </span>
                                    <span className="fw-6">
                                      {property.NoofWashroom}
                                    </span>
                                  </li>
                                )}
                                {property.PropertyFor === "Sell" && (
                                  <li className="item">
                                    <i className="icon icon-sqft" />
                                    <span className="fw-6">
                                      Land Area: {property.LandSize}
                                    </span>
                                    <span className="text-variant-1">
                                      {property.LandSizeUnit}
                                    </span>
                                  </li>
                                )}
                                {(property.PropertyFor === "Rent" ||
                                  property.PropertyFor === "PG") &&
                                property.CarpetArea
                                  ? (property.PropertyFor === "Rent" ||
                                      property.PropertyFor === "PG") &&
                                    property.CarpetArea && (
                                      <li className="item">
                                        <i className="icon icon-sqft" />

                                        <span className="fw-6">
                                          Carpet Area: {property.CarpetArea}
                                        </span>
                                        <span className="text-variant-1">
                                          {property.CarpetAreaUnitSize}
                                        </span>
                                      </li>
                                    )
                                  : (property.PropertyFor === "Rent" ||
                                        property.PropertyFor === "PG") &&
                                      property.BuiltUpArea
                                    ? (property.PropertyFor === "Rent" ||
                                        property.PropertyFor === "PG") &&
                                      property.BuiltUpArea && (
                                        <li className="item">
                                          <i className="icon icon-sqft" />
                                          <span className="fw-6">
                                            Constructed Area:{" "}
                                            {property.BuiltUpArea}
                                          </span>
                                          <span className="text-variant-1">
                                            {property.BuiltUpAreaUnitSize}
                                          </span>
                                        </li>
                                      )
                                    : (property.PropertyFor === "Rent" ||
                                          property.PropertyFor === "PG") &&
                                        property.SuperArea
                                      ? (property.PropertyFor === "Rent" ||
                                          property.PropertyFor === "PG") &&
                                        property.SuperArea && (
                                          <li className="item">
                                            <i className="icon icon-sqft" />
                                            <span className="fw-6">
                                              Constructed Area:{" "}
                                              {property.SuperArea}
                                            </span>
                                            <span className="text-variant-1">
                                              {property.SuperAreaUnitSize}
                                            </span>
                                          </li>
                                        )
                                      : null}
                              </ul>
                              <div className="mt-10 text-btn">
                                {property.PropertyFor == "Rent" ||
                                property.PropertyFor == "PG"
                                  ? `₹ ${new Intl.NumberFormat("en-IN").format(property.RentPerMonth)} /Month`
                                  : property.PropertyFor == "Sell"
                                    ? `₹ ${new Intl.NumberFormat("en-IN").format(property.ExpectedPrice)} /${property.ExpectedPricePerUnit}`
                                    : null}
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xl-8 col-lg-7 flat-animate-tab">
                  {/* Generate new selection tabs as like given screenshot in which Area is shown from the filteredProperties also it will use to filter the properties */}
                  {areaFilters.length > 0 && (
                    <div
                      className="area-filter-tabs"
                      style={{ width: "100%", marginBottom: "15px" }}
                    >
                      <ul
                        className="nav-tab-filter"
                        role="tablist"
                        style={{ flexWrap: "wrap" }}
                      >
                        <li className="nav-tab-item" role="presentation">
                          <button
                            type="button"
                            className={`nav-link-item ${!selectedAreaFilter ? "active" : ""}`}
                            onClick={() => setSelectedAreaFilter("")}
                          >
                            All
                          </button>
                        </li>
                        {areaFilters.map((area) => (
                          <li
                            className="nav-tab-item"
                            role="presentation"
                            key={area}
                          >
                            <button
                              type="button"
                              className={`nav-link-item ${normalizeText(area) === normalizeText(selectedAreaFilter) ? "active" : ""}`}
                              onClick={() => setSelectedAreaFilter(area)}
                            >
                              {area}
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  <div className="tab-content">
                    <div
                      className="tab-pane active show"
                      id="gridLayout"
                      role="tabpanel"
                    >
                      <div className="row">
                        {visibleProperties
                          .slice((page - 1) * ItemsPerPage, page * ItemsPerPage)
                          .sort((a, b) => {
                            if (sortingOption === "Price Ascending") {
                              return (
                                (a?.PropertyId ?? 0) - (b?.PropertyId ?? 0)
                              );
                            }
                            if (sortingOption === "Price Descending") {
                              return (
                                (b?.PropertyId ?? 0) - (a?.PropertyId ?? 0)
                              );
                            }
                            return 0;
                          })
                          .map((property, index) => (
                            <div key={index} className="col-md-6">
                              <div className="homelengo-box">
                                <div className="archive-top">
                                  <Link
                                    to={`/property-details/${property.AutoGeneratedURL}`}
                                    className="images-group"
                                  >
                                    <div className="images-style">
                                      <img
                                        className="lazyload"
                                        data-src={returnCardImage(
                                          property.PropertyId,
                                          property._lstPropertyImages,
                                        )}
                                        alt={property?.PropertyTitle}
                                        src={returnCardImage(
                                          property.PropertyId,
                                          property._lstPropertyImages,
                                        )}
                                        width={615}
                                        height={405}
                                        loading="lazy"
                                      />
                                    </div>
                                    <div className="top">
                                      <ul className="d-flex gap-6">
                                        {property?.IsFeatured && (
                                          <li className="flag-tag primary">
                                            Featured
                                          </li>
                                        )}

                                        <li className="flag-tag style-1">
                                          For {property?.PropertyFor}
                                        </li>
                                        <li className="flag-tag style-1">
                                          {property?.PropertyTypeName}
                                        </li>
                                      </ul>
                                    </div>
                                    <div className="bottom">
                                      <svg
                                        width={16}
                                        height={16}
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M10 7C10 7.53043 9.78929 8.03914 9.41421 8.41421C9.03914 8.78929 8.53043 9 8 9C7.46957 9 6.96086 8.78929 6.58579 8.41421C6.21071 8.03914 6 7.53043 6 7C6 6.46957 6.21071 5.96086 6.58579 5.58579C6.96086 5.21071 7.46957 5 8 5C8.53043 5 9.03914 5.21071 9.41421 5.58579C9.78929 5.96086 10 6.46957 10 7Z"
                                          stroke="white"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M13 7C13 11.7613 8 14.5 8 14.5C8 14.5 3 11.7613 3 7C3 5.67392 3.52678 4.40215 4.46447 3.46447C5.40215 2.52678 6.67392 2 8 2C9.32608 2 10.5979 2.52678 11.5355 3.46447C12.4732 4.40215 13 5.67392 13 7Z"
                                          stroke="white"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                      {property.CityName} - {property.StateName}
                                    </div>
                                  </Link>
                                </div>
                                <div className="archive-bottom">
                                  <div className="content-top">
                                    <h6 style={{ fontSize: "14px" }}>
                                      {property.PropertyGeneratedId}{" "}
                                      &nbsp;&nbsp;|&nbsp;&nbsp;{" "}
                                      {property.PropertyTitle}
                                    </h6>

                                    <h6 style={{ fontSize: "13px" }}>
                                      {property?.PropertyTypeName}
                                    </h6>
                                    <ul className="meta-list">
                                      {property.NoofRoom && (
                                        <>
                                          <li className="item">
                                            <i className="icon icon-bed" />
                                            <span className="text-variant-1">
                                              Beds:
                                            </span>
                                            <span className="fw-6">
                                              {property.NoofRoom}
                                            </span>
                                          </li>
                                        </>
                                      )}
                                      {property.NoofWashroom && (
                                        <li className="item">
                                          <i className="icon icon-bath" />
                                          <span className="text-variant-1">
                                            Baths:
                                          </span>
                                          <span className="fw-6">
                                            {property.NoofWashroom}
                                          </span>
                                        </li>
                                      )}
                                      {property.PropertyFor === "Sell" && (
                                        <li className="item">
                                          <i className="icon icon-sqft" />
                                          <span className="fw-6">
                                            Land Area: {property.LandSize}
                                          </span>
                                          <span className="text-variant-1">
                                            {property.LandSizeUnit}
                                          </span>
                                        </li>
                                      )}
                                      {(property.PropertyFor === "Rent" ||
                                        property.PropertyFor === "PG") &&
                                      property.CarpetArea
                                        ? (property.PropertyFor === "Rent" ||
                                            property.PropertyFor === "PG") &&
                                          property.CarpetArea && (
                                            <li className="item">
                                              <i className="icon icon-sqft" />

                                              <span className="fw-6">
                                                Carpet Area:{" "}
                                                {property.CarpetArea}
                                              </span>
                                              <span className="text-variant-1">
                                                {property.CarpetAreaUnitSize}
                                              </span>
                                            </li>
                                          )
                                        : (property.PropertyFor === "Rent" ||
                                              property.PropertyFor === "PG") &&
                                            property.BuiltUpArea
                                          ? (property.PropertyFor === "Rent" ||
                                              property.PropertyFor === "PG") &&
                                            property.BuiltUpArea && (
                                              <li className="item">
                                                <i className="icon icon-sqft" />
                                                <span className="fw-6">
                                                  Constructed Area:{" "}
                                                  {property.BuiltUpArea}
                                                </span>
                                                <span className="text-variant-1">
                                                  {property.BuiltUpAreaUnitSize}
                                                </span>
                                              </li>
                                            )
                                          : (property.PropertyFor === "Rent" ||
                                                property.PropertyFor ===
                                                  "PG") &&
                                              property.SuperArea
                                            ? (property.PropertyFor ===
                                                "Rent" ||
                                                property.PropertyFor ===
                                                  "PG") &&
                                              property.SuperArea && (
                                                <li className="item">
                                                  <i className="icon icon-sqft" />
                                                  <span className="fw-6">
                                                    Constructed Area:{" "}
                                                    {property.SuperArea}
                                                  </span>
                                                  <span className="text-variant-1">
                                                    {property.SuperAreaUnitSize}
                                                  </span>
                                                </li>
                                              )
                                            : null}
                                    </ul>
                                  </div>
                                  <div className="content-bottom">
                                    <div className="d-flex gap-8 align-items-center">
                                      {/* <div className="avatar avt-40 round">
                                      <img
                                        alt="avt"
                                        src={elm.avatar}
                                        width={34}
                                        height={34}
                                      />
                                    </div> */}
                                      <span>
                                        {property.BuildingTypeName}{" "}
                                        &nbsp;&nbsp;|&nbsp;&nbsp;{" "}
                                        {property.FurnishingStatus}
                                      </span>
                                    </div>
                                    <h6
                                      className="price"
                                      style={{
                                        fontSize: "16px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      {property.PropertyFor == "Rent" ||
                                      property.PropertyFor == "PG"
                                        ? `₹ ${new Intl.NumberFormat("en-IN").format(property.RentPerMonth)} /Month`
                                        : property.PropertyFor == "Sell"
                                          ? `₹ ${new Intl.NumberFormat("en-IN").format(property.ExpectedPrice)} /${property.ExpectedPricePerUnit}`
                                          : null}
                                    </h6>
                                  </div>
                                  <div className="property-contact-actions">
                                    <a
                                      onClick={() =>
                                        handleOpenEnquiry(
                                          "call",
                                          property.PropertyId,
                                        )
                                      }
                                      className="property-contact-action property-contact-action-call"
                                      aria-label="Call AskMeReality now"
                                    >
                                      <span className="icon icon-phone2" />
                                      <span>Call Now</span>
                                    </a>
                                    <a
                                      onClick={() =>
                                        handleWhatsAppClick(property)
                                      }
                                      className="property-contact-action property-contact-action-whatsapp"
                                      aria-label="Chat with AskMeReality on WhatsApp"
                                    >
                                      <span
                                        className="icon icon-whatsapp"
                                        aria-hidden="true"
                                      />
                                      <span>WhatsApp</span>
                                    </a>
                                    <button
                                      type="button"
                                      className="property-contact-action property-contact-action-enquiry"
                                      onClick={() =>
                                        handleOpenEnquiry(
                                          "enquiry",
                                          property.PropertyId,
                                        )
                                      }
                                    >
                                      <span className="icon icon-send" />
                                      <span>Enquiry</span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>

                      {visibleProperties.length === 0 && (
                        <div className="row">
                          <div className="col-12">
                            <div className="no-results no-properties-found-state">
                              {/* <div className="no-properties-found-badge">
                                <span className="icon icon-home-2" aria-hidden="true" />
                              </div> */}
                              <h3 className="title">No properties found</h3>
                              <p className="description">
                                Try adjusting your search criteria to find what
                                you're looking for.
                              </p>
                            </div>
                          </div>
                        </div>
                      )}

                      <ul className="wd-navigation mt-20">
                        {/* <Pagination
                    currentPage={currentPage}
                    setPage={setCurrentPage}
                    itemLength={sorted.length}
                    itemPerPage={itemPerPage}
                  /> */}
                        <Pagination2
                          itemLength={visibleProperties.length}
                          itemPerPage={ItemsPerPage}
                          setPage={setPage}
                        />
                      </ul>
                    </div>
                    <div className="tab-pane" id="listLayout" role="tabpanel">
                      {visibleProperties
                        .slice((page - 1) * ItemsPerPage, page * ItemsPerPage)
                        .sort((a, b) => {
                          if (sortingOption === "Price Ascending") {
                            return (a?.PropertyId ?? 0) - (b?.PropertyId ?? 0);
                          }
                          if (sortingOption === "Price Descending") {
                            return (b?.PropertyId ?? 0) - (a?.PropertyId ?? 0);
                          }
                          return 0;
                        })
                        .map((property, index) => (
                          <div key={index} className="col-md-12">
                            <div className="homelengo-box list-style-1 list-style-2 line">
                              <div className="archive-top">
                                <Link
                                  to={`/property-details/${property.AutoGeneratedURL}`}
                                  className="images-group"
                                >
                                  <div className="images-style">
                                    <img
                                      className="lazyload"
                                      alt={property?.PropertyTitle}
                                      src={returnCardImage(
                                        property.PropertyId,
                                        property._lstPropertyImages,
                                      )}
                                      width={344}
                                      height={315}
                                    />
                                  </div>
                                  <div className="top">
                                    <ul className="d-flex gap-6 flex-wrap">
                                      {property?.IsFeatured && (
                                        <li className="flag-tag primary">
                                          Featured
                                        </li>
                                      )}
                                      <li className="flag-tag style-1">
                                        For {property?.PropertyFor}
                                      </li>
                                      <li className="flag-tag style-1">
                                        {property?.PropertyTypeName}
                                      </li>
                                    </ul>
                                  </div>
                                </Link>
                              </div>
                              <div className="archive-bottom">
                                <div className="content-top">
                                  <h6 className="text-capitalize">
                                    <Link
                                      to={`/property-details/${property.AutoGeneratedURL}`}
                                      className="link text-line-clamp-1"
                                    >
                                      {property.PropertyGeneratedId}{" "}
                                      &nbsp;&nbsp;|&nbsp;&nbsp;{" "}
                                      {property.PropertyTitle}
                                    </Link>
                                  </h6>
                                  <h6 style={{ fontSize: "13px" }}>
                                    {property?.PropertyTypeName}
                                  </h6>
                                  <ul className="meta-list">
                                    {property.NoofRoom && (
                                      <>
                                        <li className="item">
                                          <i className="icon icon-bed" />
                                          <span className="text-variant-1">
                                            Beds:
                                          </span>
                                          <span className="fw-6">
                                            {property.NoofRoom}
                                          </span>
                                        </li>
                                      </>
                                    )}
                                    {property.NoofWashroom && (
                                      <li className="item">
                                        <i className="icon icon-bath" />
                                        <span className="text-variant-1">
                                          Baths:
                                        </span>
                                        <span className="fw-6">
                                          {property.NoofWashroom}
                                        </span>
                                      </li>
                                    )}
                                    {property.PropertyFor === "Sell" && (
                                      <li className="item">
                                        <i className="icon icon-sqft" />
                                        <span className="fw-6">
                                          Land Area: {property.LandSize}
                                        </span>
                                        <span className="text-variant-1">
                                          {property.LandSizeUnit}
                                        </span>
                                      </li>
                                    )}
                                    {(property.PropertyFor === "Rent" ||
                                      property.PropertyFor === "PG") &&
                                    property.CarpetArea
                                      ? (property.PropertyFor === "Rent" ||
                                          property.PropertyFor === "PG") &&
                                        property.CarpetArea && (
                                          <li className="item">
                                            <i className="icon icon-sqft" />

                                            <span className="fw-6">
                                              Carpet Area: {property.CarpetArea}
                                            </span>
                                            <span className="text-variant-1">
                                              {property.CarpetAreaUnitSize}
                                            </span>
                                          </li>
                                        )
                                      : (property.PropertyFor === "Rent" ||
                                            property.PropertyFor === "PG") &&
                                          property.BuiltUpArea
                                        ? (property.PropertyFor === "Rent" ||
                                            property.PropertyFor === "PG") &&
                                          property.BuiltUpArea && (
                                            <li className="item">
                                              <i className="icon icon-sqft" />
                                              <span className="fw-6">
                                                Constructed Area:{" "}
                                                {property.BuiltUpArea}
                                              </span>
                                              <span className="text-variant-1">
                                                {property.BuiltUpAreaUnitSize}
                                              </span>
                                            </li>
                                          )
                                        : (property.PropertyFor === "Rent" ||
                                              property.PropertyFor === "PG") &&
                                            property.SuperArea
                                          ? (property.PropertyFor === "Rent" ||
                                              property.PropertyFor === "PG") &&
                                            property.SuperArea && (
                                              <li className="item">
                                                <i className="icon icon-sqft" />
                                                <span className="fw-6">
                                                  Constructed Area:{" "}
                                                  {property.SuperArea}
                                                </span>
                                                <span className="text-variant-1">
                                                  {property.SuperAreaUnitSize}
                                                </span>
                                              </li>
                                            )
                                          : null}
                                  </ul>
                                  <div className="location">
                                    <svg
                                      width={16}
                                      height={16}
                                      viewBox="0 0 16 16"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M10 7C10 7.53043 9.78929 8.03914 9.41421 8.41421C9.03914 8.78929 8.53043 9 8 9C7.46957 9 6.96086 8.78929 6.58579 8.41421C6.21071 8.03914 6 7.53043 6 7C6 6.46957 6.21071 5.96086 6.58579 5.58579C6.96086 5.21071 7.46957 5 8 5C8.53043 5 9.03914 5.21071 9.41421 5.58579C9.78929 5.96086 10 6.46957 10 7Z"
                                        stroke="#A3ABB0"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M13 7C13 11.7613 8 14.5 8 14.5C8 14.5 3 11.7613 3 7C3 5.67392 3.52678 4.40215 4.46447 3.46447C5.40215 2.52678 6.67392 2 8 2C9.32608 2 10.5979 2.52678 11.5355 3.46447C12.4732 4.40215 13 5.67392 13 7Z"
                                        stroke="#A3ABB0"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                    <span className="text-line-clamp-1">
                                      {property.CityName} - {property.StateName}
                                    </span>
                                  </div>
                                </div>
                                <div className="content-bottom">
                                  <div className="d-flex gap-8 align-items-center">
                                    {/* <div className="avatar avt-40 round">
                                <img
                                  alt="avt"
                                  src={elm.avatar}
                                  width={34}
                                  height={34}
                                />
                              </div> */}
                                    <span>
                                      {property.BuildingTypeName}{" "}
                                      &nbsp;&nbsp;|&nbsp;&nbsp;{" "}
                                      {property.FurnishingStatus}
                                    </span>
                                  </div>
                                  <h6
                                    className="price"
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {property.PropertyFor == "Rent" ||
                                    property.PropertyFor == "PG"
                                      ? `₹ ${new Intl.NumberFormat("en-IN").format(property.RentPerMonth)} /Month`
                                      : property.PropertyFor == "Sell"
                                        ? `₹ ${new Intl.NumberFormat("en-IN").format(property.ExpectedPrice)} /${property.ExpectedPricePerUnit}`
                                        : null}
                                  </h6>
                                </div>
                                <div className="property-contact-actions">
                                  <a
                                    onClick={() => {
                                      handleOpenEnquiry(
                                        "call",
                                        property.PropertyId,
                                      );
                                    }}
                                    className="property-contact-action property-contact-action-call"
                                    aria-label="Call AskMeReality now"
                                  >
                                    <span className="icon icon-phone2" />
                                    <span>Call Now</span>
                                  </a>
                                  <a
                                    onClick={() =>
                                      handleWhatsAppClick(property)
                                    }
                                    className="property-contact-action property-contact-action-whatsapp"
                                    aria-label="Chat with AskMeReality on WhatsApp"
                                  >
                                    <span
                                      className="icon icon-whatsapp"
                                      aria-hidden="true"
                                    />
                                    <span>WhatsApp</span>
                                  </a>
                                  <button
                                    type="button"
                                    className="property-contact-action property-contact-action-enquiry"
                                    onClick={() =>
                                      handleOpenEnquiry(
                                        "enquiry",
                                        property.PropertyId,
                                      )
                                    }
                                  >
                                    <span className="icon icon-send" />
                                    <span>Enquiry</span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      <ul className="wd-navigation mt-20">
                        {/* <Pagination
                    currentPage={page}
                    setPage={setPage}
                    itemLength={filteredProperties.length}
                    itemPerPage={ItemsPerPage}
                  /> */}
                        <Pagination2
                          itemLength={visibleProperties.length}
                          itemPerPage={ItemsPerPage}
                          setPage={setPage}
                        />
                      </ul>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="col-xl-8 col-lg-7 flat-animate-tab">
                  <div className="tab-content">
                    <div
                      className="tab-pane active show"
                      id="gridLayout"
                      role="tabpanel"
                    >
                      <div className="row">
                        {visibleProperties
                          .slice((page - 1) * ItemsPerPage, page * ItemsPerPage)
                          .sort((a, b) => {
                            if (sortingOption === "Price Ascending") {
                              return (
                                (a?.PropertyId ?? 0) - (b?.PropertyId ?? 0)
                              );
                            }
                            if (sortingOption === "Price Descending") {
                              return (
                                (b?.PropertyId ?? 0) - (a?.PropertyId ?? 0)
                              );
                            }
                            return 0;
                          })
                          .map((property, index) => (
                            <div key={index} className="col-md-6">
                              <div className="homelengo-box">
                                <div className="archive-top">
                                  <Link
                                    to={`/property-details/${property.AutoGeneratedURL}`}
                                    className="images-group"
                                  >
                                    <div className="images-style">
                                      <img
                                        className="lazyload"
                                        data-src={returnCardImage(
                                          property.PropertyId,
                                          property._lstPropertyImages,
                                        )}
                                        alt={property?.PropertyTitle}
                                        src={returnCardImage(
                                          property.PropertyId,
                                          property._lstPropertyImages,
                                        )}
                                        width={615}
                                        height={405}
                                        loading="lazy"
                                      />
                                    </div>
                                    <div className="top">
                                      <ul className="d-flex gap-6">
                                        {property?.IsFeatured && (
                                          <li className="flag-tag primary">
                                            Featured
                                          </li>
                                        )}

                                        <li className="flag-tag style-1">
                                          For {property?.PropertyFor}
                                        </li>
                                        <li className="flag-tag style-1">
                                          {property?.PropertyTypeName}
                                        </li>
                                      </ul>
                                    </div>
                                    <div className="bottom">
                                      <svg
                                        width={16}
                                        height={16}
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M10 7C10 7.53043 9.78929 8.03914 9.41421 8.41421C9.03914 8.78929 8.53043 9 8 9C7.46957 9 6.96086 8.78929 6.58579 8.41421C6.21071 8.03914 6 7.53043 6 7C6 6.46957 6.21071 5.96086 6.58579 5.58579C6.96086 5.21071 7.46957 5 8 5C8.53043 5 9.03914 5.21071 9.41421 5.58579C9.78929 5.96086 10 6.46957 10 7Z"
                                          stroke="white"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M13 7C13 11.7613 8 14.5 8 14.5C8 14.5 3 11.7613 3 7C3 5.67392 3.52678 4.40215 4.46447 3.46447C5.40215 2.52678 6.67392 2 8 2C9.32608 2 10.5979 2.52678 11.5355 3.46447C12.4732 4.40215 13 5.67392 13 7Z"
                                          stroke="white"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                      {property.CityName} - {property.StateName}
                                    </div>
                                  </Link>
                                </div>
                                <div className="archive-bottom">
                                  <div className="content-top">
                                    <h6 style={{ fontSize: "14px" }}>
                                      {property.PropertyGeneratedId}{" "}
                                      &nbsp;&nbsp;|&nbsp;&nbsp;{" "}
                                      {property.PropertyTitle}
                                    </h6>

                                    <h6 style={{ fontSize: "13px" }}>
                                      {property?.PropertyTypeName}
                                    </h6>
                                    <ul className="meta-list">
                                      {property.NoofRoom && (
                                        <>
                                          <li className="item">
                                            <i className="icon icon-bed" />
                                            <span className="text-variant-1">
                                              Beds:
                                            </span>
                                            <span className="fw-6">
                                              {property.NoofRoom}
                                            </span>
                                          </li>
                                        </>
                                      )}
                                      {property.NoofWashroom && (
                                        <li className="item">
                                          <i className="icon icon-bath" />
                                          <span className="text-variant-1">
                                            Baths:
                                          </span>
                                          <span className="fw-6">
                                            {property.NoofWashroom}
                                          </span>
                                        </li>
                                      )}
                                      {property.PropertyFor === "Sell" && (
                                        <li className="item">
                                          <i className="icon icon-sqft" />
                                          <span className="fw-6">
                                            Land Area: {property.LandSize}
                                          </span>
                                          <span className="text-variant-1">
                                            {property.LandSizeUnit}
                                          </span>
                                        </li>
                                      )}
                                      {(property.PropertyFor === "Rent" ||
                                        property.PropertyFor === "PG") &&
                                      property.CarpetArea
                                        ? (property.PropertyFor === "Rent" ||
                                            property.PropertyFor === "PG") &&
                                          property.CarpetArea && (
                                            <li className="item">
                                              <i className="icon icon-sqft" />

                                              <span className="fw-6">
                                                Carpet Area:{" "}
                                                {property.CarpetArea}
                                              </span>
                                              <span className="text-variant-1">
                                                {property.CarpetAreaUnitSize}
                                              </span>
                                            </li>
                                          )
                                        : (property.PropertyFor === "Rent" ||
                                              property.PropertyFor === "PG") &&
                                            property.BuiltUpArea
                                          ? (property.PropertyFor === "Rent" ||
                                              property.PropertyFor === "PG") &&
                                            property.BuiltUpArea && (
                                              <li className="item">
                                                <i className="icon icon-sqft" />
                                                <span className="fw-6">
                                                  Constructed Area:{" "}
                                                  {property.BuiltUpArea}
                                                </span>
                                                <span className="text-variant-1">
                                                  {property.BuiltUpAreaUnitSize}
                                                </span>
                                              </li>
                                            )
                                          : (property.PropertyFor === "Rent" ||
                                                property.PropertyFor ===
                                                  "PG") &&
                                              property.SuperArea
                                            ? (property.PropertyFor ===
                                                "Rent" ||
                                                property.PropertyFor ===
                                                  "PG") &&
                                              property.SuperArea && (
                                                <li className="item">
                                                  <i className="icon icon-sqft" />
                                                  <span className="fw-6">
                                                    Constructed Area:{" "}
                                                    {property.SuperArea}
                                                  </span>
                                                  <span className="text-variant-1">
                                                    {property.SuperAreaUnitSize}
                                                  </span>
                                                </li>
                                              )
                                            : null}
                                    </ul>
                                  </div>
                                  <div className="content-bottom">
                                    <div className="d-flex gap-8 align-items-center">
                                      {/* <div className="avatar avt-40 round">
                                      <img
                                        alt="avt"
                                        src={elm.avatar}
                                        width={34}
                                        height={34}
                                      />
                                    </div> */}
                                      <span>
                                        {property.BuildingTypeName}{" "}
                                        &nbsp;&nbsp;|&nbsp;&nbsp;{" "}
                                        {property.FurnishingStatus}
                                      </span>
                                    </div>
                                    <h6
                                      className="price"
                                      style={{
                                        fontSize: "16px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      {property.PropertyFor == "Rent" ||
                                      property.PropertyFor == "PG"
                                        ? `₹ ${new Intl.NumberFormat("en-IN").format(property.RentPerMonth)} /Month`
                                        : property.PropertyFor == "Sell"
                                          ? `₹ ${new Intl.NumberFormat("en-IN").format(property.ExpectedPrice)} /${property.ExpectedPricePerUnit}`
                                          : null}
                                    </h6>
                                  </div>
                                  <div className="property-contact-actions">
                                    <a
                                      onClick={() =>
                                        handleOpenEnquiry(
                                          "call",
                                          property.PropertyId,
                                        )
                                      }
                                      className="property-contact-action property-contact-action-call"
                                      aria-label="Call AskMeReality now"
                                    >
                                      <span className="icon icon-phone2" />
                                      <span>Call Now</span>
                                    </a>
                                    <a
                                      onClick={() =>
                                        handleWhatsAppClick(property)
                                      }
                                      className="property-contact-action property-contact-action-whatsapp"
                                      aria-label="Chat with AskMeReality on WhatsApp"
                                    >
                                      <span
                                        className="icon icon-whatsapp"
                                        aria-hidden="true"
                                      />
                                      <span>WhatsApp</span>
                                    </a>
                                    <button
                                      type="button"
                                      className="property-contact-action property-contact-action-enquiry"
                                      onClick={() =>
                                        handleOpenEnquiry(
                                          "enquiry",
                                          property.PropertyId,
                                        )
                                      }
                                    >
                                      <span className="icon icon-send" />
                                      <span>Enquiry</span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>

                      {visibleProperties.length === 0 && (
                        <div className="row">
                          <div className="col-12">
                            <div className="no-results no-properties-found-state">
                              {/* <div className="no-properties-found-badge">
                                <span className="icon icon-home-2" aria-hidden="true" />
                              </div> */}
                              <h3 className="title">No properties found</h3>
                              <p className="description">
                                Try adjusting your search criteria to find what
                                you're looking for.
                              </p>
                            </div>
                          </div>
                        </div>
                      )}

                      <ul className="wd-navigation mt-20">
                        {/* <Pagination
                    currentPage={currentPage}
                    setPage={setCurrentPage}
                    itemLength={sorted.length}
                    itemPerPage={itemPerPage}
                  /> */}
                        <Pagination2
                          itemLength={visibleProperties.length}
                          itemPerPage={ItemsPerPage}
                          setPage={setPage}
                        />
                      </ul>
                    </div>
                    <div className="tab-pane" id="listLayout" role="tabpanel">
                      {visibleProperties
                        .slice((page - 1) * ItemsPerPage, page * ItemsPerPage)
                        .sort((a, b) => {
                          if (sortingOption === "Price Ascending") {
                            return (a?.PropertyId ?? 0) - (b?.PropertyId ?? 0);
                          }
                          if (sortingOption === "Price Descending") {
                            return (b?.PropertyId ?? 0) - (a?.PropertyId ?? 0);
                          }
                          return 0;
                        })
                        .map((property, index) => (
                          <div key={index} className="col-md-12">
                            <div className="homelengo-box list-style-1 list-style-2 line">
                              <div className="archive-top">
                                <Link
                                  to={`/property-details/${property.AutoGeneratedURL}`}
                                  className="images-group"
                                >
                                  <div className="images-style">
                                    <img
                                      className="lazyload"
                                      alt={property?.PropertyTitle}
                                      src={returnCardImage(
                                        property.PropertyId,
                                        property._lstPropertyImages,
                                      )}
                                      width={344}
                                      height={315}
                                    />
                                  </div>
                                  <div className="top">
                                    <ul className="d-flex gap-6 flex-wrap">
                                      {property?.IsFeatured && (
                                        <li className="flag-tag primary">
                                          Featured
                                        </li>
                                      )}
                                      <li className="flag-tag style-1">
                                        For {property?.PropertyFor}
                                      </li>
                                      <li className="flag-tag style-1">
                                        {property?.PropertyTypeName}
                                      </li>
                                    </ul>
                                  </div>
                                </Link>
                              </div>
                              <div className="archive-bottom">
                                <div className="content-top">
                                  <h6 className="text-capitalize">
                                    <Link
                                      to={`/property-details/${property.AutoGeneratedURL}`}
                                      className="link text-line-clamp-1"
                                    >
                                      {property.PropertyGeneratedId}{" "}
                                      &nbsp;&nbsp;|&nbsp;&nbsp;{" "}
                                      {property.PropertyTitle}
                                    </Link>
                                  </h6>
                                  <h6 style={{ fontSize: "13px" }}>
                                    {property?.PropertyTypeName}
                                  </h6>
                                  <ul className="meta-list">
                                    {property.NoofRoom && (
                                      <>
                                        <li className="item">
                                          <i className="icon icon-bed" />
                                          <span className="text-variant-1">
                                            Beds:
                                          </span>
                                          <span className="fw-6">
                                            {property.NoofRoom}
                                          </span>
                                        </li>
                                      </>
                                    )}
                                    {property.NoofWashroom && (
                                      <li className="item">
                                        <i className="icon icon-bath" />
                                        <span className="text-variant-1">
                                          Baths:
                                        </span>
                                        <span className="fw-6">
                                          {property.NoofWashroom}
                                        </span>
                                      </li>
                                    )}
                                    {property.PropertyFor === "Sell" && (
                                      <li className="item">
                                        <i className="icon icon-sqft" />
                                        <span className="fw-6">
                                          Land Area: {property.LandSize}
                                        </span>
                                        <span className="text-variant-1">
                                          {property.LandSizeUnit}
                                        </span>
                                      </li>
                                    )}
                                    {(property.PropertyFor === "Rent" ||
                                      property.PropertyFor === "PG") &&
                                    property.CarpetArea
                                      ? (property.PropertyFor === "Rent" ||
                                          property.PropertyFor === "PG") &&
                                        property.CarpetArea && (
                                          <li className="item">
                                            <i className="icon icon-sqft" />

                                            <span className="fw-6">
                                              Carpet Area: {property.CarpetArea}
                                            </span>
                                            <span className="text-variant-1">
                                              {property.CarpetAreaUnitSize}
                                            </span>
                                          </li>
                                        )
                                      : (property.PropertyFor === "Rent" ||
                                            property.PropertyFor === "PG") &&
                                          property.BuiltUpArea
                                        ? (property.PropertyFor === "Rent" ||
                                            property.PropertyFor === "PG") &&
                                          property.BuiltUpArea && (
                                            <li className="item">
                                              <i className="icon icon-sqft" />
                                              <span className="fw-6">
                                                Constructed Area:{" "}
                                                {property.BuiltUpArea}
                                              </span>
                                              <span className="text-variant-1">
                                                {property.BuiltUpAreaUnitSize}
                                              </span>
                                            </li>
                                          )
                                        : (property.PropertyFor === "Rent" ||
                                              property.PropertyFor === "PG") &&
                                            property.SuperArea
                                          ? (property.PropertyFor === "Rent" ||
                                              property.PropertyFor === "PG") &&
                                            property.SuperArea && (
                                              <li className="item">
                                                <i className="icon icon-sqft" />
                                                <span className="fw-6">
                                                  Constructed Area:{" "}
                                                  {property.SuperArea}
                                                </span>
                                                <span className="text-variant-1">
                                                  {property.SuperAreaUnitSize}
                                                </span>
                                              </li>
                                            )
                                          : null}
                                  </ul>
                                  <div className="location">
                                    <svg
                                      width={16}
                                      height={16}
                                      viewBox="0 0 16 16"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M10 7C10 7.53043 9.78929 8.03914 9.41421 8.41421C9.03914 8.78929 8.53043 9 8 9C7.46957 9 6.96086 8.78929 6.58579 8.41421C6.21071 8.03914 6 7.53043 6 7C6 6.46957 6.21071 5.96086 6.58579 5.58579C6.96086 5.21071 7.46957 5 8 5C8.53043 5 9.03914 5.21071 9.41421 5.58579C9.78929 5.96086 10 6.46957 10 7Z"
                                        stroke="#A3ABB0"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M13 7C13 11.7613 8 14.5 8 14.5C8 14.5 3 11.7613 3 7C3 5.67392 3.52678 4.40215 4.46447 3.46447C5.40215 2.52678 6.67392 2 8 2C9.32608 2 10.5979 2.52678 11.5355 3.46447C12.4732 4.40215 13 5.67392 13 7Z"
                                        stroke="#A3ABB0"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                    <span className="text-line-clamp-1">
                                      {property.CityName} - {property.StateName}
                                    </span>
                                  </div>
                                </div>
                                <div className="content-bottom">
                                  <div className="d-flex gap-8 align-items-center">
                                    {/* <div className="avatar avt-40 round">
                                <img
                                  alt="avt"
                                  src={elm.avatar}
                                  width={34}
                                  height={34}
                                />
                              </div> */}
                                    <span>
                                      {property.BuildingTypeName}{" "}
                                      &nbsp;&nbsp;|&nbsp;&nbsp;{" "}
                                      {property.FurnishingStatus}
                                    </span>
                                  </div>
                                  <h6
                                    className="price"
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {property.PropertyFor == "Rent" ||
                                    property.PropertyFor == "PG"
                                      ? `₹ ${new Intl.NumberFormat("en-IN").format(property.RentPerMonth)} /Month`
                                      : property.PropertyFor == "Sell"
                                        ? `₹ ${new Intl.NumberFormat("en-IN").format(property.ExpectedPrice)} /${property.ExpectedPricePerUnit}`
                                        : null}
                                  </h6>
                                </div>
                                <div className="property-contact-actions">
                                  <a
                                    onClick={() => {
                                      handleOpenEnquiry(
                                        "call",
                                        property.PropertyId,
                                      );
                                    }}
                                    className="property-contact-action property-contact-action-call"
                                    aria-label="Call AskMeReality now"
                                  >
                                    <span className="icon icon-phone2" />
                                    <span>Call Now</span>
                                  </a>
                                  <a
                                    onClick={() =>
                                      handleOpenEnquiry(
                                        "whatsapp",
                                        property.PropertyId,
                                      )
                                    }
                                    className="property-contact-action property-contact-action-whatsapp"
                                    aria-label="Chat with AskMeReality on WhatsApp"
                                  >
                                    <span
                                      className="icon icon-whatsapp"
                                      aria-hidden="true"
                                    />
                                    <span>WhatsApp</span>
                                  </a>
                                  <button
                                    type="button"
                                    className="property-contact-action property-contact-action-enquiry"
                                    onClick={() =>
                                      handleOpenEnquiry(
                                        "enquiry",
                                        property.PropertyId,
                                      )
                                    }
                                  >
                                    <span className="icon icon-send" />
                                    <span>Enquiry</span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      <ul className="wd-navigation mt-20">
                        {/* <Pagination
                    currentPage={page}
                    setPage={setPage}
                    itemLength={filteredProperties.length}
                    itemPerPage={ItemsPerPage}
                  /> */}
                        <Pagination2
                          itemLength={visibleProperties.length}
                          itemPerPage={ItemsPerPage}
                          setPage={setPage}
                        />
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-5">
                  <div className="widget-sidebar fixed-sidebar">
                    <div className="flat-tab flat-tab-form widget-filter-search widget-box">
                      <ul className="nav-tab-form" role="tablist">
                        <li className="nav-tab-item" role="presentation">
                          <a
                            className="nav-link-item active"
                            data-bs-toggle="tab"
                            onClick={() => setPropertyStatus("Rent")}
                          >
                            Rent
                          </a>
                        </li>
                        <li className="nav-tab-item" role="presentation">
                          <a
                            className="nav-link-item"
                            data-bs-toggle="tab"
                            onClick={() => setPropertyStatus("Sell")}
                          >
                            Sale
                          </a>
                        </li>
                        <li className="nav-tab-item" role="presentation">
                          <a
                            className="nav-link-item"
                            data-bs-toggle="tab"
                            onClick={() => setPropertyStatus("PG")}
                          >
                            PG
                          </a>
                        </li>
                      </ul>
                      <div className="tab-content">
                        <div
                          className="tab-pane fade active show"
                          role="tabpanel"
                        >
                          <div className="form-sl">
                            <form onSubmit={(e) => e.preventDefault()}>
                              <div className="wd-filter-select">
                                <div className="inner-group">
                                  <div className="box">
                                    <div className="form-style">
                                      <div className="group-ip ip-icon">
                                        <input
                                          type="text"
                                          className="form-control"
                                          defaultValue=""
                                          name="s"
                                          title="Search for"
                                          required
                                          value={selectedLocation}
                                          onClick={() => setModalOpen(true)}
                                          readOnly
                                          placeholder="Search by location"
                                        />
                                        <a
                                          className="icon-right icon-location"
                                          onClick={() => {
                                            setModalOpen(true);
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <LocationModal
                                      isOpen={modalOpen}
                                      onClose={() => setModalOpen(false)}
                                      onSelect={setSelectedLocation}
                                    />
                                    <div className="form-style">
                                      <input
                                        type="text"
                                        className="form-control"
                                        defaultValue=""
                                        title="Search for"
                                        required
                                        placeholder="Search Keyword"
                                        name="s"
                                        value={selectedLocationKeyword}
                                        onClick={() =>
                                          setModalOpenKeyword(true)
                                        }
                                      />
                                    </div>
                                    <KeywordSearch
                                      isOpen={modalOpenKeyword}
                                      onClose={() => setModalOpenKeyword(false)}
                                      onSelect={setSelectedLocationKeyword}
                                      LocationName={selectedLocation}
                                    />
                                  </div>
                                  <div className="form-style">
                                    <button
                                      type="submit"
                                      className="tf-btn btn-view primary hover-btn-view"
                                      onClick={() => getFinalFilteredData()}
                                    >
                                      Find Properties
                                      <span className="icon icon-arrow-right2" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="widget-box box-latest-property">
                      <h5 className="fw-6 title">Latest Propeties</h5>
                      <ul>
                        {top8Properties.map((property, index) => (
                          <li key={index} className="latest-property-item">
                            <Link
                              to={`/property-details/${property.AutoGeneratedURL}`}
                              className="images-style"
                            >
                              <img
                                data-src={returnCardImage(
                                  property.PropertyId,
                                  property._lstPropertyImages,
                                )}
                                alt={property?.PropertyTitle}
                                src={returnCardImage(
                                  property.PropertyId,
                                  property._lstPropertyImages,
                                )}
                                width={615}
                                height={405}
                                loading="lazy"
                              />
                            </Link>
                            <div className="content">
                              <div className="text-capitalize text-btn">
                                <Link
                                  to={`/property-details/${property.AutoGeneratedURL}`}
                                  className="link"
                                >
                                  {property.PropertyGeneratedId}{" "}
                                  &nbsp;&nbsp;|&nbsp;&nbsp;
                                  {property.PropertyFor}{" "}
                                  &nbsp;&nbsp;|&nbsp;&nbsp;{" "}
                                  {property.PropertyTitle}
                                </Link>
                              </div>
                              <ul className="meta-list mt-6">
                                {property.NoofRoom && (
                                  <>
                                    <li className="item">
                                      <i className="icon icon-bed" />
                                      <span className="text-variant-1">
                                        Beds:
                                      </span>
                                      <span className="fw-6">
                                        {property.NoofRoom}
                                      </span>
                                    </li>
                                  </>
                                )}
                                {property.NoofWashroom && (
                                  <li className="item">
                                    <i className="icon icon-bath" />
                                    <span className="text-variant-1">
                                      Baths:
                                    </span>
                                    <span className="fw-6">
                                      {property.NoofWashroom}
                                    </span>
                                  </li>
                                )}
                                {property.PropertyFor === "Sell" && (
                                  <li className="item">
                                    <i className="icon icon-sqft" />
                                    <span className="fw-6">
                                      Land Area: {property.LandSize}
                                    </span>
                                    <span className="text-variant-1">
                                      {property.LandSizeUnit}
                                    </span>
                                  </li>
                                )}
                                {(property.PropertyFor === "Rent" ||
                                  property.PropertyFor === "PG") &&
                                property.CarpetArea
                                  ? (property.PropertyFor === "Rent" ||
                                      property.PropertyFor === "PG") &&
                                    property.CarpetArea && (
                                      <li className="item">
                                        <i className="icon icon-sqft" />

                                        <span className="fw-6">
                                          Carpet Area: {property.CarpetArea}
                                        </span>
                                        <span className="text-variant-1">
                                          {property.CarpetAreaUnitSize}
                                        </span>
                                      </li>
                                    )
                                  : (property.PropertyFor === "Rent" ||
                                        property.PropertyFor === "PG") &&
                                      property.BuiltUpArea
                                    ? (property.PropertyFor === "Rent" ||
                                        property.PropertyFor === "PG") &&
                                      property.BuiltUpArea && (
                                        <li className="item">
                                          <i className="icon icon-sqft" />
                                          <span className="fw-6">
                                            Constructed Area:{" "}
                                            {property.BuiltUpArea}
                                          </span>
                                          <span className="text-variant-1">
                                            {property.BuiltUpAreaUnitSize}
                                          </span>
                                        </li>
                                      )
                                    : (property.PropertyFor === "Rent" ||
                                          property.PropertyFor === "PG") &&
                                        property.SuperArea
                                      ? (property.PropertyFor === "Rent" ||
                                          property.PropertyFor === "PG") &&
                                        property.SuperArea && (
                                          <li className="item">
                                            <i className="icon icon-sqft" />
                                            <span className="fw-6">
                                              Constructed Area:{" "}
                                              {property.SuperArea}
                                            </span>
                                            <span className="text-variant-1">
                                              {property.SuperAreaUnitSize}
                                            </span>
                                          </li>
                                        )
                                      : null}
                              </ul>
                              <div className="mt-10 text-btn">
                                {property.PropertyFor == "Rent" ||
                                property.PropertyFor == "PG"
                                  ? `₹ ${new Intl.NumberFormat("en-IN").format(property.RentPerMonth)} /Month`
                                  : property.PropertyFor == "Sell"
                                    ? `₹ ${new Intl.NumberFormat("en-IN").format(property.ExpectedPrice)} /${property.ExpectedPricePerUnit}`
                                    : null}
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <Enquiry
          isOpen={isEnquiryOpen}
          onClose={handleCloseEnquiry}
          onSubmit={handleEnquirySubmit}
          flagType={FlagType}
          propertyId={PropertyId}
        />
      </section>
      <BlogDetails2
        pageUrlMasterData={pageUrlMasterData}
        filteredpageUrlMasterData={filteredpageUrlMasterData}
      />
    </>
  );
}
